import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=6d967ae2&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentStatus.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d967ae2",
  null
  
)

export default component.exports